import { render, staticRenderFns } from "./barchartdash.vue?vue&type=template&id=8339a51a&"
import script from "./barchartdash.vue?vue&type=script&lang=js&"
export * from "./barchartdash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports